import axios from 'axios';
import { getToken, getRefresh, setTokens, clearTokens } from './auth';
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const api = axios.create({ baseURL: BASE });
api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = 'Bearer ' + token;
  return config;
});
api.interceptors.response.use(
  res => res,
  async err => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      const refresh = getRefresh();
      if (refresh) {
        try {
          const res = await axios.post(BASE + '/auth/token/refresh/', { refresh });
          setTokens(res.data.access, refresh);
          orig.headers.Authorization = 'Bearer ' + res.data.access;
          return api(orig);
        } catch { clearTokens(); window.location.href = '/login'; }
      } else { clearTokens(); window.location.href = '/login'; }
    }
    return Promise.reject(err);
  }
);
export default api;
